import { render, staticRenderFns } from "./EditPending.vue?vue&type=template&id=2f5afefc"
import script from "./EditPending.vue?vue&type=script&lang=js"
export * from "./EditPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports